// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3nfHq","left":"styles_left__YhWLM","leftBody":"styles_leftBody__c0GAA","right":"styles_right__3wgF-","collapse":"styles_collapse__D6Bft"};